import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCbscWSt7KXJNvYEEtT1lICtImNVNvW5BQ",
  authDomain: "mercado-intimo.firebaseapp.com",
  projectId: "mercado-intimo",
  storageBucket: "mercado-intimo.firebasestorage.app",
  messagingSenderId: "618873145562",
  appId: "1:618873145562:web:93060803de3d42e1c8bde3",
  measurementId: "G-WGZLNJJ6CZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);
export default app;
